/** Safe `.mp3` filename for Content-Disposition headers and browser downloads. */
export function mp3FilenameFromTitle(title: string, fallback = "ai-summary"): string {
  const slug = title
    .toLowerCase()
    .replace(/\.mp3$/i, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60);
  return `${slug || fallback}.mp3`;
}
